import React, { Fragment } from 'react'

// import AlphabetList from 'react-alphabet-list'

import { DropDownIcon } from 'components/Common/SvgIcons'
import { DictionaryWrapper } from 'components/Clients/style'
import DictionaryList from 'components/Common/DictionaryList'
import TackleAvatarLogo from 'components/Common/TackleAvatarLogo'

export default function DirectoryList({ alphabetListData, filteredList, clientList }) {
  return (
    <DictionaryWrapper>
      <div className="w-full">
        <div
          id="client-directory-list"
          className="w-full border-t border-grey-lighter overflow-y-auto bg-white"
          style={{ maxHeight: 'calc(100vh - 250px)' }}
        >
          {
            filteredList?.length > 0 &&
              alphabetListData.map((item, index) => {
                const client = filteredList?.find(
                  ({ firstName, id }) => `${firstName || ''}${id}` === item
                )
                const logo = client?.logo?.url || ''
                return (
                  <Fragment key={item + index}>
                    <DictionaryList client={client}>
                      <div className="flex items-center gap-3 flex-1 min-w-0">
                        <div className="relative h-[40px] w-[40px] flex-shrink-0">
                          <TackleAvatarLogo
                            logo={logo}
                            className="bg-blue-lighter1x h-[40px] w-[40px] rounded-full"
                            firstName={client.firstName}
                            lastName={client.lastName}
                          />
                        </div>
                        <div className="flex flex-col flex-1 min-w-0">
                          <p className="text-black-light font-primary text-base font-normal leading-snug truncate m-0">
                            {`${client?.firstName || ''} ${client?.lastName || ''}`}
                          </p>
                          <p className="text-sm font-normal text-silver font-primary leading-snug truncate m-0 mt-0.5">
                            {client?.businessName || ''}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center flex-shrink-0">
                        <DropDownIcon className="h-[20px] w-[20px] fill-silver rotate-[270deg]" />
                      </div>
                    </DictionaryList>
                  </Fragment>
                )
              })
            // <AlphabetList
            //   className="alpha-list"
            //   data={alphabetListData}
            //   generateFn={(item, index) => {
            //     const client = filteredList?.find(
            //       ({ firstName, id }) => `${firstName}${id}` === item
            //     )
            //     return (
            //       <Fragment key={item + index}>
            //         <DictionaryList client={client}>
            //           <div className="inline-flex">
            //             <div className="relative">
            //               <TackleAvatarLogo className="bg-primary h-[51px] w-[50.57px] icon-color  group-hover:bg-primary-brand" />
            //             </div>
            //             <div className="flex-col ml-4 inline-flex cursor-pointer">
            //               <div>
            //                 <p className="text-zinc font-primary text-lg font-semibold">
            //                   {`${client?.firstName || ''} ${client?.lastName || ''}`}
            //                 </p>
            //               </div>
            //               <div>
            //                 <p className="text-sm font-semibold text-zinc font-primary">
            //                   {client?.businessName || ''}
            //                 </p>
            //               </div>
            //             </div>
            //           </div>
            //           <div
            //             className={`${
            //               isMobileOnly ? 'mr-10' : isTablet ? 'mr-6' : ''
            //             } xxl:mr-4 flex items-center`}
            //           >
            //             <DropDownIcon className="h-[25px] w-[20px] fill-primary rotate-[270deg]" />
            //           </div>
            //         </DictionaryList>
            //       </Fragment>
            //     )
            //   }}
            // />
          }
          {filteredList?.length === 0 && clientList?.length === 0 && (
            <p className="text-base font-semibold p-6">You have no active clients.</p>
          )}
          {filteredList?.length === 0 && clientList?.length > 0 && (
            <p className="text-base font-semibold p-6">0 results found.</p>
          )}
        </div>
      </div>
    </DictionaryWrapper>
  )
}
